import { Component, OnInit, ViewChild, ElementRef, Renderer2, Input, EventEmitter, Output, SecurityContext } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.sass']
})
export class PostComponent implements OnInit {

  @ViewChild('post', {read: ElementRef}) post;
  @ViewChild('edit', {read: ElementRef}) edit;

  @ViewChild('moreDescription', {read: ElementRef}) moreDescription;
  @Input() single_post: {};
  @Input() totalPosts: number;

  @Output() edittingPost = new EventEmitter()
  @Output() reloadPostData = new EventEmitter();

  open = false
  deleted = false
  constructor(private renderer: Renderer2, private sanitizer: DomSanitizer, private fireUpload:AngularFireStorage, private apiService: ApiService) { }

  ngOnInit(): void {
    this.single_post['details'] = this.sanitizer.sanitize(1, this.single_post['details'])
  }

  postShow() {
    if (this.open === false) {
      this.post.nativeElement.style.display = "flex"
      this.edit.nativeElement.style.display = "flex"

      this.renderer.addClass(this.moreDescription.nativeElement, "moreDescription")
      this.open = true
    }

    else {
      this.post.nativeElement.style.display = "none"
      this.edit.nativeElement.style.display = "none"

      this.renderer.removeClass(this.moreDescription.nativeElement, "moreDescription")
      this.open = false 
    }
  }

  deletePost(val, urls) {
    this.deleted = true
    for (let i in urls) {
      try {
        this.fireUpload.storage.refFromURL(urls[i]).delete()
      }

      catch(err) {
        console.log('Firebase ran into an error.', err)
      }
    }
    this.apiService.deletePost(val).subscribe(data => this.reloadPostData.emit('delete'))

  }

  turnOnEdit(postEdit) {
    postEdit['details'] = this.sanitizer.bypassSecurityTrustHtml(this.single_post['details'])
    this.edittingPost.emit(postEdit)
  }
  

}
